import { isBrowserEnv } from "@visactor/vrender-core/env";

export const isBrowser = isBrowserEnv();

export const domDocument = isBrowser && globalThis ? globalThis.document : void 0;

export function isTrueBrowser(mode) {
    return ("desktop-browser" === mode || "mobile-browser" === mode) && isBrowser;
}

export function isPcLikeMode(mode) {
    return "desktop-miniApp" === mode || "desktop-browser" === mode;
}

export function isMobileLikeMode(mode) {
    return isMiniAppLikeMode(mode) || "mobile-browser" === mode;
}

export function isMiniAppLikeMode(mode) {
    return mode.includes("miniApp") || "lynx" === mode || "wx" === mode || "harmony" === mode;
}
//# sourceMappingURL=env.js.map
